<template>
  <div class="create-group">
    <div class="top">
      <div class="plan" @click="cancel">广告计划</div>
      <div>></div>
      <div class="new" v-text="(type === 'add' ? '新建' : '编辑') + '推广组'"></div>
    </div>
    <div class="create-plan">
      <el-form label-width="120px" ref="form" label-position="left" :model="form" :rules="rules">
        <div class="form-title">基本属性</div>
        <el-form-item label="所属计划" prop="plan_id">
          <el-select v-model="form.plan_id" placeholder="请选择" style="width: 350px;">
            <el-option :label="item.title" :value="item.plan_id" v-for="(item, index) in planLists" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="推广组名称" prop="group_name">
          <el-input v-model="form.group_name" style="width: 350px;" placeholder="请输入广告计划名称"></el-input>
        </el-form-item>
        <el-form-item label="落地页地址" prop="url">
          <el-input v-model="form.url" style="width: 350px;" placeholder="http://"></el-input>
        </el-form-item>
        <el-form-item label="投放目标">
          <el-radio-group v-model="form.type">
            <el-radio border label="1">打开网页</el-radio>
            <el-radio border label="2">安卓应用下载</el-radio>
            <el-radio border label="3">苹果应用下载</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" @click="submitForm('form', 'groupCancel')">保存并关闭</el-button>
          <el-button @click="cancel">取 消</el-button>
        </el-form-item>
      </el-form>
      <!-- <div style="position: fixed; z-index: 10; background: #fff; width: 1200px; left: calc(50% - 600px); height: 80px; bottom: 0; display: flex; align-items: center; justify-content: center;">
        <el-button type="primary" @click="submitForm('form', 'groupCancel')">保存并关闭</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div> -->

      <div class="tips">
        <div class="tips-title">温馨提示</div>
        <div class="tips-content">
          <div>原生广告中添加的广告创意统一在右侧“广告创意列表""中管理</div>
          <div>默认落地页为在广告中未填写，或者系统检测到广告创意内落地页失效的情况下进行替换。</div>
          <div>广告交互类型视广告创意类型而定，并非所有广告创意都会生效。</div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'createGroup',
  props: ['group_data'],
  data() {
    return {
      form: {
        group_id: '',
        plan_id: '',
        type: '1',
        url: '',
        group_name: ''
      },
      type: 'add',
      rules: {
        plan_id: [
          { required: true, message: '请选择计划', trigger: 'change' }
        ],
        group_name: [
          { required: true, message: '请输入单元名称', trigger: 'blur' },
          { min: 0, max: 30, message: '长度不能超过30个字符', trigger: 'blur' }
        ],
        url: [
          { required: true, message: '请输入落地页地址', trigger: 'blur' }
        ]
      },
      planLists: []
    };
  },
  created() {
    // 编辑
    if (this.group_data.group_id !== undefined && parseInt(this.group_data.group_id) > 0) {
      this.form = {
        group_id: this.group_data.group_id,
        plan_id: this.group_data.plan_id,
        type: this.group_data.type + '',
        url: this.group_data.url,
        group_name: this.group_data.group_name
      };
      this.type = 'edit';
    }
    this.$http.post('/trader/index/group_form', {
      group_id: this.form.group_id
    }).then(res => {
      if (res.code === 200) {
        this.planLists = res.data.plan_lists;
        this.$function.hiddenLoading();
        // this.getData();
      }
    });
  },
  methods: {
    getData() {
      this.$http.post('/trader/index/getGroupPlanLists', {
        keyword: this.keyword,
        page: this.page,
        pageSize: this.pageSize
      }).then(res => {
        if (res.code === 200) {
          this.tableData = res.data;
          this.pageTotal = Math.ceil(res.count / this.pageSize);
          this.$function.hiddenLoading();
        }
      });
    },
    submitForm(formName, make) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const url = this.type === 'add' ? '/trader/index/createGroupPlan' : '/trader/index/saveGroupPlan';
          this.$http.post(url, this.form).then(res => {
            if (res.code === 200) {
              this.$message.success('操作成功');
              this.$emit('plan_call_back', make);
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    cancel() {
      this.$emit('plan_call_back', 'groupCancel');
    }
  }
};
</script>

<style lang="less">
  .create-group {
    .form-title {
      color: #1890ff;
      line-height: 20px;
      font-size: 16px;
      border-left: 2px solid #1890ff;
      padding-left: 8px;
      margin-bottom: 40px;
    }
    .font {
      font-size: 12px;
      font-weight: 400;
      color: #909399;
      p {
        height: 20px;
        line-height: 25px;
      }
    }
    .create-plan {
      background: #fff;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      overflow-y: auto;
      border-radius: 4px;
      padding: 30px 20px 0 20px;
    }
    .top {
      margin-bottom: 24px;
      display: flex;
      align-items: center;
      height: 64px;
      font-size: 14px;
      color: #606266;
      background: #fff;
      padding: 0 25px;
      div {
        margin-right: 5px;
      }
      .plan:hover {
        cursor: pointer;
        color: #1890FF;
      }
    }
    .el-radio-button__inner {
      background: #f3f9fe;
      -webkit-box-shadow: none;
      box-shadow: none;
      border: 1px solid #1890ff;
      color: #1890ff;
      line-height: 1;
      white-space: nowrap;
      vertical-align: middle;
      background: #fff;
      border: 1px solid #dcdfe6;
      font-weight: 500;
      border-left: 0;
      color: #606266;
      -webkit-appearance: none;
      text-align: center;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      margin: 0;
      cursor: pointer;
      -webkit-transition: all .3s cubic-bezier(.645,.045,.355,1);
      transition: all .3s cubic-bezier(.645,.045,.355,1);
      padding: 12px 20px;
      font-size: 14px;
      border-radius: 0;
    }

    .is-active .el-radio-button__inner {
        background: #f3f9fe;
        -webkit-box-shadow: none;
        box-shadow: none;
        border: 1px solid #1890ff;
        color: #1890ff;
    }
  }

  .tips {
    padding: 30px;
    font-size: 16px;
    font-weight: 700;
    color: #9F9F9F;
    border-top: 1px solid #CFCFCF;
    .tips-content {
      margin-top: 10px;
      padding: 0 30px;
      color: #CFCFCF;
      font-size: 14px;
      font-weight: normal;
    }
  }

</style>
